import type { SiteReadable } from "../../../services/client/types.gen";
import type { BoardSite } from "./boardColumns";

export const PARTNER_SITE_PARTNER_IDS = [
  "pxc",
  "catael",
  "reno-energy",
  "neargrid",
  "eniris-demo",
  "wtg-teleport",
  "zeno",
  "vma",
  "pxc_be_duplicate",
];

export type SiteStatus = NonNullable<SiteReadable["status"]>;

export const SITE_STATUSES: SiteStatus[] = ["active", "inactive", "shadow"];

export type SiteFilters = {
  search: string;
  partnerIds: string[];
  statuses: SiteStatus[];
  hidePartnerSites: boolean;
};

export const filterBoardSites = (
  sites: BoardSite[],
  { search, partnerIds, statuses, hidePartnerSites }: SiteFilters,
  partnerNameById: Record<string, string>,
): BoardSite[] => {
  const term = search.trim().toLowerCase();
  return sites.filter(({ site }) => {
    if (
      hidePartnerSites &&
      PARTNER_SITE_PARTNER_IDS.includes(site.partner_id)
    ) {
      return false;
    }
    if (partnerIds.length > 0 && !partnerIds.includes(site.partner_id)) {
      return false;
    }
    if (statuses.length > 0 && !statuses.includes(site.status ?? "inactive")) {
      return false;
    }
    if (!term) {
      return true;
    }
    return [
      site.name,
      site.site_id,
      site.partner_id,
      partnerNameById[site.partner_id],
    ].some((value) => value?.toLowerCase().includes(term));
  });
};
